// extracted by mini-css-extract-plugin
module.exports = {"plan":"plan_rVPre","planButton":"planButton_lGi3P","planPrice":"planPrice_pvIw5"};